/**
 * @file actions/Content/constants.js
 * @copyright 2016 CBC/Radio-Canada. All rights reserved.
 */

export const AD_IU = 5876;

export const DEFAULT_PAGE_DESCRIPTION =
    "Canada's home for news, sports, lifestyle, comedy, arts, kids, music, original series & more.";

// This is a list of facebook page IDs for verticals (top-level pages)
const FACEBOOK_PAGE_IDS_OF_VERTICALS = [
    "185669354938012", // CBC (Parent Channel)
    "48363581912", // CBC Radio
    "980153248675210", // CBC Arts
    "50566954493", // CBC Books
    "262275773829225", // CBC Music
    "630185150356988", // CBC Comedy
    "82184406949", // CBC Docs
    "9021636963", // CBC Life
    "5823419603", // CBC News
    "325135839870", // CBC Sports
    "192209947577094", // CBC Olympics
    "234303596639900", // CBC Kids
];

// As a default, a list of facepage pages IDs that relate to top-level pages will be used.
export const DEFAULT_FACEBOOK_PAGE_IDS = FACEBOOK_PAGE_IDS_OF_VERTICALS.join();
export const NO_INDEX_TYPES = ["contentpackage"];

export const NAMES = {
    description: "",
    "vf:container_id": "",
    "twitter:card": "summary_large_image",
    "twitter:site": "@cbc",
    "twitter:title": "",
    "twitter:description": "",
    "twitter:image": "",
    "twitter:player": "",
    "twitter:player:width": "640",
    "twitter:player:height": "360",
    "google-site-verification": "pJy_QmRvDz2tr7X8eQ6Y1L3Se-8RWM_PpJX42Pr_fYo",
    robots: "",
};

export const PROPERTIES = {
    "vf:url": "",
    "vf:container_id": "",
    "vf:section": "",
    "og:url": "",
    "og:title": "",
    "og:image": "",
    "og:description": "",
    "og:type": "website",
    "fb:pages": DEFAULT_FACEBOOK_PAGE_IDS,
    "og:locale": "en_US",
    "og:site_name": "CBC",
    "video:duration": "",
    "video:release_date": "",
};

export const LINKS = {
    canonical: "",
};

export const SCRIPTS = {
    jsonld: null,
};
